import React from "react";
import PropTypes from "prop-types";
import "./style.css";

const VaporTab = props => {
  const {
    active,
    containerStyle,
    customClass,
    items,
    itemsStyle,
    onChange,
    hideBorder,
    wrap,
    type
  } = props;

  const renderItems = () => {
    let itRet = [];
    if (items) {
      items.map((it, index) => {
        return itRet.push(<div
          className={
            `vapor-itemContainer ${active === it.value ? "active" : ""}`
          }
          style={itemsStyle}
          id={"vapor-itemContainer_" + it.value}
          key={index}
          onClick={() => {
            if (onChange) {
              onChange(it);
            }
          }}
        >
          {it.content || it.value}
        </div>);
      });
    }
    return itRet;
  };

  let additionalClassnames = "";
  if (wrap) {
    additionalClassnames += " wrap";
  }
  if (hideBorder) {
    additionalClassnames += " hide-border";
  }
  if (type) {
    additionalClassnames += " " + type;
  }

  return (
    <div
      style={containerStyle}
      className={`vapor-tabContainer ${additionalClassnames} ${customClass}`}
    >
      {renderItems()}
    </div>
  );
};

VaporTab.propTypes = {
  active: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  containerStyle: PropTypes.object,
  customClass: PropTypes.string,
  items: PropTypes.array,
  itemsStyle: PropTypes.object,
  onChange: PropTypes.func,
  hideBorder: PropTypes.bool,
  wrap: PropTypes.bool,
  type: PropTypes.string
};

VaporTab.defaultProps = {
  active: "",
  containerStyle: {},
  items: [],
  itemsStyle: {},
  onChange: null,
  hideBorder: false,
  wrap: false,
  type: ""
};

export default VaporTab;
